import React, { Component } from 'react'
import { connect } from 'react-redux'
import { utils } from 'alelo-logic'
import moment from 'moment'
import { fetchResendStatement } from 'alelo-logic/actions'
import { Icon } from '../Icon'

import {
  Text,
  ListItem,
  ItemTitle,
  ItemIcon,
  ItemBullet,
  Bullet,
  ItemDescription,
  ItemPrice,
  Price,
  ResendButton
} from './styles'

const formatTime = info => {
  let time = ''
  if (info.type === 'park' && info.value < 0) {
    time = (
      <Text>
        <span>
          <b>Utilizado em</b>
          <time>{utils.ISODateFormat(info.date)}</time>
        </span>
        <span>
          <b>Entrada</b>
          <time>{utils.timeFormat(moment(info.startTime, 'HH:mm:ss'))}</time>
        </span>
        <span>
          <b>Saída</b>
          <time>{utils.timeFormat(moment(info.exitTime, 'HH:mm:ss'))}</time>
        </span>
        <span>
          <b>Permanência</b>
          <time>{info.stayTime}</time>
        </span>
        {info.vehicle.placa && (
          <span>
            <b>Placa</b>
            <time>{info.vehicle.placa}</time>
          </span>
        )}
      </Text>
    )
  } else if (info.type === 'payment') {
    time = (
      <Text>
        <span>
          <b>Recebido em</b>
          <time>{utils.ISODateFormat(info.date)}</time>
        </span>
        <span>
          <b>Hora</b>
          <time>{utils.timeFormat(moment(info.startTime, 'HH:mm:ss'))}</time>
        </span>
      </Text>
    )
  } else if (info.value > 0) {
    time = (
      <Text>
        <span>
          <b>Realizada em</b>
          <time>{utils.ISODateFormat(info.date)}</time>
        </span>
        <span>
          <b>Hora</b>
          <time>{utils.timeFormat(moment(info.startTime, 'HH:mm:ss'))}</time>
        </span>
      </Text>
    )
  } else {
    time = (
      <Text>
        <span>
          <b>Utilizado em</b>
          <time>{utils.ISODateFormat(info.date)}</time>
        </span>
        <span>
          <b>Hora</b>
          <time>{utils.timeFormat(moment(info.startTime, 'HH:mm:ss'))}</time>
        </span>
        {info.type === 'toll' &&
          info.vehicle.placa && (
            <span>
              <b>Placa</b>
              <time>{info.vehicle.placa}</time>
            </span>
          )}
        {info.tollFreeVeloeId && (
          <span>
            <br />
            <b>NÚMERO DA VIAGEM</b>
            <time>{info.tollFreeVeloeId}</time>
          </span>
        )}
      </Text>
    )
  }
  return time
}

const displayStatementIcon = (type, value) => {
  let width = '100'
  let heigth = '70'
  if (type === 'tax') {
    return (
      <ItemBullet>
        <Bullet type={type} />
      </ItemBullet>
    )
  }
  if (type === 'recharge') {
    width = '200px'
    heigth = '140px'
  }
  return value > 0 ? (
    <ItemIcon>
      <Icon
        width="24"
        height="26"
        icon={type}
        color="#d7dd1a"
        viewBox={`-15 0 ${width} ${heigth}`}
      />
    </ItemIcon>
  ) : (
    <ItemIcon>
      <Icon
        width="24"
        height="26"
        icon={type}
        color="#8583a4"
        viewBox={`-15 0 ${width} ${heigth}`}
      />
    </ItemIcon>
  )
}

class StatementsListItem extends Component {
  state = {
    resent: false
  }

  setResent = ({ fastId }) => {
    this.props.fetchResend(fastId)
    this.setState({ resent: true })
  }

  render() {
    const { match, ...statement } = this.props

    return (
      <ListItem value={statement.value}>
        {displayStatementIcon(statement.type, statement.value)}
        <ItemDescription>
          <ItemTitle type={statement.type}>
            {statement.tollFree && 'VALE PEDÁGIO - '}
            {statement.title}
          </ItemTitle>
          <Text>{`${statement.code} ${statement.details ? ` - ${statement.details}` : ''}`}</Text>
          {formatTime(statement)}
        </ItemDescription>
        <ItemPrice>
          <Price type={statement.type}>
            {statement.value.toFixed(2) > 0
              ? '+' + statement.value.toFixed(2)
              : statement.value.toFixed(2)}
          </Price>
          {statement.partner &&
            (!this.state.resent ? (
              <ResendButton
                onClick={() => this.setResent(statement)}
                id="resend"
                className="resend"
                title="Reenviar transação"
              >
                Reenviar
              </ResendButton>
            ) : (
              <img src={require('./icon-check.png')} alt="Transação reenviada com sucesso!" />
            ))}
          {/* <ContestButton
            to={`/minha-veloe/${match.params.id}/extrato/${statement.id}/contestacao`}
            className="contest"
          >
            Contestar
          </ContestButton>
          <ContestButtonMobile to={`/minha-veloe/2/extrato/${statement.id}/contestacao`}>
            <img src={require('./icon-contest.png')} alt="" />
          </ContestButtonMobile> */}
        </ItemPrice>
      </ListItem>
    )
  }
}

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  fetchResend: fastId =>
    dispatch(fetchResendStatement(fastId)).then(() => {
      // if (resp && resp.status === 204) {
      //   dispatch(setLoading(false))
      // }
      // dispatch(setLoading(false))
    })
})

export default connect(mapStateToProps, mapDispatchToProps)(StatementsListItem)



// WEBPACK FOOTER //
// ./src/app/elements/StatementsListItem/index.js